import React, {Component, Fragment} from "react"
import Price from "components/Price/Price"
import OrderModel   from "shop/OrderModel";
import shop from "shop/shop"
import {Button, Icon, Message, Modal, Form,Dropdown,TextArea, Image, Input} from "semantic-ui-react"
import { Checkbox,
	Card,
	Col,
	FormField,
	FormInput,
	Row,
  } from "elemental-react16"
import {observer} from "mobx-react"
import languageStore from "stores/languageStore"
import ProductImages from "components/Product/ProductImages"
import htmr                                                                           from "htmr";
import ImageWithFallback from "components/ImageWithFallback"

@observer
export default class ProductPriceInquiry extends Component {

	constructor() {
		super()
		this.state = {
      customerAccessibility: "",
      agb: false,
      privacy: false,
      newReq: {
        firm: {
          article_id: "",
          articleQuantity: 0,
          customernumber: ""
        },
        person: {
          salutation: "",
          firstname: "",
          lastname: ""
        },
        contact: {
          email: "",
          phone: "",
          mobile: "",
          comment: ""
        },
      }
		}
	}

  
    handleSendServiceRequest = async (product) =>{
      if(this.state.newReq.contact.email == "" || this.state.newReq.contact.phone == "" || this.state.newReq.person.salutation == "" || this.state.newReq.person.firstname == "" || this.state.newReq.person.lastname == ""){ 
        shop.toast(translate("Bitte alle Pflichtfelder ausfüllen!"))
        return
      }
      await this.setState(prevState => {
        let newReq = { ...prevState.newReq };
        newReq.firm.article_id = product.map_id;
        newReq.firm.customernumber = shop.session && shop.session.value && shop.session.value.map_id ? shop.session.value.map_id : "";
        return { newReq };
      });
      try {
        await shop.fetch( `/shop/rest/service/request?id=price_request`, {
          method: "POST",
          credentials: "include",
          body: JSON.stringify( this.state.newReq ),
        } ) 
        shop.toast( `Ihre Anfrage wurde erfolgreich versendet`, "info", false, "bottom" )
        setTimeout(() => {
          this.props.onCloseModal();
        }, 1000);
        console.log("newReq: ", this.state.newReq)
        const delay = ms => new Promise(
          resolve => setTimeout(resolve, ms)
        );
      }
      catch (err) {
      console.log( err )
      shop.toast( err )
      }
    }

  render(){
  const {customerAccessibility} = this.state
  let {product, modaleOpen} = this.props
  let img_srcs = product.img_srcs
  let productImage = false
  if ( product.img_src ) {
    productImage = product.img_src_large
  }


  const { currentLanguage } = languageStore
  let genderOptions =[ ]
  if(currentLanguage == 'fr'){
  genderOptions = [
    { key: 'male', value: 'Herr', text: 'Monsieur' },
    { key: 'female', value: 'Frau', text: 'Madame' },
  ]
  }
  else{
  genderOptions = [
    { key: 'male', value: 'Herr', text: 'Herr' },
    { key: 'female', value: 'Frau', text: 'Frau' },
    { key: 'diverse', value: 'Divers', text: 'Divers' },
  ]
  }

  const handleChange = (event) => {
  //console.log("CHANGE: ", event.target)
  let tempname = event.target.name
  let tempname2 = event.target.className
  let tempvalue = event.target.value
  this.setState(prevState => {
    let newReq = { ...prevState.newReq };  
    newReq[tempname][tempname2] = tempvalue;       
    return { newReq }; 
    })
  }; 

  const handleDropDownChange = (event, {value}) => {
    let tempvalue = value
    this.setState(prevState => {
      let newReq = { ...prevState.newReq };  
      if(value == "Herr" || value == "Frau" || value == "Divers"){
        newReq.person.salutation = tempvalue
      } 
      else if(this.state.form2Disabled == false){
        newReq.address.country = tempvalue
      } 
      else if(this.state.form3Disabled == false){
        newReq.address.delivercountry = tempvalue
      }     
      return { newReq }; 
      })
    }; 

  const handleCommentChange = ( event ) => {
    //console.log("VALUE:",event.target)
    let comment = event.target.value
    this.setState(prevState => {
      let newReq = { ...prevState.newReq };  
      newReq.contact.comment = comment;       
      return { newReq }; 
      })
    }

  return <Fragment>
  <Modal
   className="pl3 pr3"
  closeIcon={<Icon name="pt3 close" />}
  open={modaleOpen}
  onClose={() => {
    this.props.onCloseModal();
  }}
  size="small"
  >
  <Modal.Header>{translate( `Anfrage für ein Angebot: ${product.map_id}` )}</Modal.Header>
  <Modal.Content className="pl3" scrolling>

<div className="pb2">
  <table>
    <colgroup>
    <col width="30%"/>
    <col width="70%"/>
    </colgroup>
    <tbody>
      <tr>
        <td> 
                      <div key={product.img_src_small} className="pl2 pt2 pb2">
                      <ImageWithFallback style={{maxWidth:"200px",maxHeight:"200px",overflow: "hidden"}}
                        fallback={"/image/placeholder.png"}
                        alt={`${product.title}`}
                        title={`${product.title}`}
                        src={product.img_src_small} />
                    </div>               
          </td>
        <td>
          <p>Artikelnummer: {product.article_nr}</p>
          <p>{htmr(product.desc.des)}</p>
        </td>
      </tr>
      </tbody>
  </table>
</div>
<div className="pb4">
  <p>Angefragte Menge:</p>
  <p className="f6 black-50">Wie viele Einheiten wollen Sie bestellen?</p>
  <Input min={1}
				defaultValue={1}
        value={this.state.newReq.firm.articleQuantity} onChange={handleChange}
				className="text-center"
				type="number"
				placeholder="0"
				action>
          				<Button
					size="tiny"
					icon="minus"
					onClick={() => {
              //LOGIC MISSING
              this.setState(prevState => {
                let newReq = { ...prevState.newReq };
                newReq.firm.articleQuantity = Math.max(1, parseInt(newReq.firm.articleQuantity) - 1);
                return { newReq };
              });
					}} />
				<input value={this.state.newReq.firm.articleQuantity }  className="articleQuantity" name="firm" tabIndex={99} style={{minWidth: "60px", maxWidth: "70px"}} />
				<Button
					size="tiny"
					icon="plus"
					onClick={() => {
              //LOGIC MISSING
              this.setState(prevState => {
                let newReq = { ...prevState.newReq };
                newReq.firm.articleQuantity = Math.max(1, parseInt(newReq.firm.articleQuantity) + 1);
                return { newReq };
              });
					}} />
          <p className="f3 pl3 pt1">{product.quantities[0] ? product.quantities[0].des : "Stück"}</p>
			</Input>
      
</div>

  <div>
     <Form>
      <div>
    <h3>{translate("Angaben zu Ihrer Person")}</h3>
              <Form.Field required>
                <label>{translate("Anrede")}</label>
                <Dropdown
                  value={this.state.newReq.person.salutation}
                  onChange={handleDropDownChange}
                  clearable
                  label="Land:"
                  className="salutation" 
                  name="person"
                  required
                  selection
                  options={genderOptions}
                  placeholder={translate("Anrede")}
                />
              </Form.Field>
              <Form.Group widths="equal">
                <Form.Input required label={translate("Vorname")}><input fluid value={this.state.newReq.person.firstname} onChange={handleChange} className="firstname" test="firstname" name="person" label="Vorname:" placeholder={translate("Vorname")}  /></Form.Input>
                <Form.Input required label={translate("Nachname")}><input fluid value={this.state.newReq.person.lastname} onChange={handleChange} className="lastname" name="person" label="Nachname:" placeholder={translate("Nachname")}  /></Form.Input>
              </Form.Group></div>
            </Form>
  <Form>
          <div style={{minHeight: "400px"}}>
          <h3>{translate("Erreichbarkeit")}</h3>
            <Form.Field required>
              <label>{translate("E-Mail")}</label>
              <input value={this.state.newReq.contact.email} onChange={handleChange} className="email" name="contact" nameadd="email" placeholder={translate("E-Mail")} />
            </Form.Field>
            <Form.Group widths="equal">
            <Form.Input required label={translate("Telefon")}><input value={this.state.newReq.contact.phone} onChange={handleChange} required fluid className="phone" name="contact" label="Telefon:" placeholder={translate("Telefon")}  /></Form.Input>
            <Form.Input label={translate("Mobil")}><input value={this.state.newReq.contact.mobile} onChange={handleChange} fluid className="mobile" name="contact" label="Mobil:" placeholder={translate("Mobil")}  /></Form.Input>
            </Form.Group>
            <FormField label={translate( "comment" )} htmlFor="supported-controls-input">
                 <FormInput placeholder={translate( "commentPlaceholder" )} value={this.state.newReq.contact.comment} onChange={handleCommentChange} multiline/>
                    </FormField>
            </div>
          </Form>
  </div>
  <div className="pt1 flex flex-row justify-between">
  <Button className="pb2" primary onClick={() => this.props.onCloseModal()} >Zurück</Button>
  <Button className="pb2" primary onClick={() => this.handleSendServiceRequest(product)}>Absenden</Button>
  </div>
  </Modal.Content>

</Modal>
</Fragment>
}
}


// WEBPACK FOOTER //
// ./src/theme/hvz/components/Product/ProductPriceInquiry.js